/**
 * tlc.ls2pac.utils.AcceleratedReaderUtil
 */
export class AcceleratedReaderUtil {
	constructor() {}

	static isThereAnyReadingLevelInfo(currentResource) {
		for (let key in currentResource.acceleratedReader) {
			if (Object.prototype.hasOwnProperty.call(currentResource.acceleratedReader, key)) {
				if (currentResource.acceleratedReader[key]) {
					return true;
				}
			}
		}
		for (let key in currentResource.lexile) {
			if (Object.prototype.hasOwnProperty.call(currentResource.lexile, key)) {
				if (currentResource.lexile[key]) {
					return true;
				}
			}
		}
		return false;
	}
}

